export function createCheckboxs (checkboxs = []){
checkboxs = checkboxs
    .map((checkbox) => {
      return `
      <div class="form-checkbox">
      <label>
        <input
          name="${checkbox.name}"
          type="checkbox"
          class="filled-in"
          ${checkbox.checked ? 'checked' : ''}
        />
        <span>${checkbox.name}</span>
      </label>
    </div>
    `;
    })
    .join("");

    return '<div class="form-group">' + checkboxs + '</div>'
}

export function createInputs (imputs){
  imputs = imputs
    .map((imput) => {
      return `
  <div class="form-imput">
   <label for="${imput.name}">${imput.name}</label>
    <div>
    <input
    name="${imput.name || ''}"
    type="${imput.type || 'number'}"
    value="${imput.value || ''}"
    class="${imput.class || ''}" /> : ${imput.type}
    </div>
    </div>
    `;
    })
    .join("");

    return '<div class="inputs form-group">' + imputs + '</div>'
}

export function createSelects (selects){

 const selcts = selects.map((select) => {
    return `<div class="form-selects form-group">
    <label>${select.name}</label>
     <select name='${select.name}' class='browser-default' >` +
     select.options
       .map((option) => {
         return `<option name="${select.name}" value="${option}" >${option}</option>`;
       })
       .join("") +
     "</select> </div>";
  }).join('')
  return selcts
}
